import Model from './model'
import { classInstanceToObject } from '../common/utils'
import { BACKEND_URL } from '../config'


export default class Filter extends Model {
  static get name() {
    return 'filters'
  }

  static get channelOptions() {
    return { EMAIL: 'Email' }
  }

  get url() {
    return `${BACKEND_URL}/infrastructure/transfer-filters`
  }

  toObject() {
    return classInstanceToObject(this)
  }
}
